import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Icon from "../Icon";

const CmsLink = ({ id, className, style, url, text }) => {
  const attributes = { id, className, style };
  if (url.startsWith("mailto:")) {
    attributes.target = "_blank";
  }
  // eslint-disable-next-line no-script-url
  if (url.startsWith("javascript:")) {
    const jsCode = url.substr(11);
    // eslint-disable-next-line no-new-func
    attributes.onClick = new Function(jsCode);
    attributes.className = "link";
  }
  return url.indexOf("//") > -1 ? (
    <a href={url} rel="noopener noreferrer" target="_blank" {...attributes}>
      {text} <Icon name="arrow-up-right-from-square" />
    </a>
  ) : typeof attributes.onClick === "function" ? (
    <span {...attributes}>{text}</span>
  ) : (
    <Link to={url} {...attributes}>
      {text}
    </Link>
  );
};

CmsLink.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  url: PropTypes.string.isRequired,
  text: PropTypes.any.isRequired
};

export default CmsLink;
